import React, { Component } from "react"

//component
import { termprivacy } from "../ConstData/constTermPrivacy"
import { eventGetReactGA } from "../../gafunction"

//material ui
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Button from "@material-ui/core/Button"

class TermandPrivacy extends Component {
	componentDidMount() {
		window.fbq("track", "TermsandPrivacyView")
		eventGetReactGA({
			category: "PageView",
			action: "Click Terms and Privacy"
		})
	}
	render() {
		const { Open, handleClickClose, t } = this.props
		return (
			<Dialog
				open={Open}
				onClose={handleClickClose}
				fullWidth={true}
				maxWidth="md"
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="scroll-dialog-title" style={{ fontSize: "1rem" }}>
					<b>Terms & Privacy</b>
				</DialogTitle>
				<DialogContent>
					<DialogContentText component={"span"}>
						{termprivacy()}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						aria-label="handleClickClose"
						onClick={handleClickClose}
						color="primary"
					>
						{t("button.buttonclose")}
					</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

export default TermandPrivacy
